<template>
  <v-form
      ref="form"
      lazy-validation
  >
    <v-row>
      <v-col cols="4">
        <v-text-field
            dense
            label="Código"
            type="number"
            min="0"
            required
            v-model="acceptanceRule.code"
            :rules="[$util.formrules.required]"
            :error-messages="errors.code"
            outlined
        />
      </v-col>
      <v-col cols="8">
        <v-textarea
            dense
            label="Descrição"
            clear-icon="mdi-close-circle"
            required
            v-model="acceptanceRule.description"
            :rules="[$util.formrules.required]"
            :error-messages="errors.description"
            outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
            dense
            label="Mínimo de vidas"
            required
            v-mask="$util.formmasks.number"
            v-model="acceptanceRule.minimumLives"
            :rules="[$util.formrules.required]"
            :error-messages="errors.minimumLives"
            outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
            dense
            label="Máximo de Vidas"
            required
            v-mask="$util.formmasks.number"
            v-model="acceptanceRule.maximumLives"
            :rules="[$util.formrules.required]"
            :error-messages="errors.maximumLives"
            outlined
        />
      </v-col>
      <v-col cols="4">
        <v-checkbox
            v-if="!!acceptanceRule.id"
            dense
            outlined
            v-model="acceptanceRule.active"
            :false-value="false"
            :true-value="true"
            label="Ativo"
        ></v-checkbox>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  props: {
    acceptanceRule: {
      type: Object
    },
    errors: {
      type: Object
    }
  },
  data() {
    return {};
  },
  methods: {
    model() {
      return this.acceptanceRule;
    },
    validate() {
      return this.$refs.form.validate();
    },
    goBack() {
      this.$router.back()
    }
  }
};
</script>


